export function initModals() {
  document.addEventListener('click', e => {
    const openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      const id = openBtn.dataset.modalOpen;
      const modal = document.querySelector(`[data-modal="${id}"]`);
      const backdrop = document.querySelector(`[data-modal-backdrop="${id}"]`) || (modal && modal.querySelector('[data-modal-backdrop]'));
      if (modal) openModal(modal, backdrop);
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('[data-modal]');
      const id = modal ? modal.dataset.modal : null;
      const backdrop = id ? document.querySelector(`[data-modal-backdrop="${id}"]`) : (modal && modal.querySelector('[data-modal-backdrop]'));
      if (modal) closeModal(modal, backdrop);
    }

    if (e.target.hasAttribute('data-modal-backdrop')) {
      const modal = e.target.closest('[data-modal]') || document.querySelector(`[data-modal="${e.target.dataset.modalBackdrop}"]`);
      const backdrop = e.target;
      if (modal) closeModal(modal, backdrop);
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      const openModals = document.querySelectorAll('[data-modal].active, [data-modal]:not(.hidden)');
      openModals.forEach(modal => {
        if (!modal.classList.contains('hidden')) {
          const id = modal.dataset.modal;
          const backdrop = document.querySelector(`[data-modal-backdrop="${id}"]`) || modal.querySelector('[data-modal-backdrop]');
          closeModal(modal, backdrop);
        }
      });
    }
  });
}

function openModal(modal, backdrop) {
  modal.classList.remove('hidden');
  modal.classList.add('active');
  if (backdrop) {
    backdrop.classList.remove('hidden');
    backdrop.classList.add('active');
  }
  const content = modal.querySelector('.modal-content');
  if (content) content.classList.add('active');
  document.body.classList.add('overflow-hidden');
}

function closeModal(modal, backdrop) {
  if (!modal) return;
  modal.classList.add('hidden');
  modal.classList.remove('active');
  if (backdrop) {
    backdrop.classList.add('hidden');
    backdrop.classList.remove('active');
  }
  const content = modal.querySelector('.modal-content');
  if (content) content.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}
